import oAuthStorage from './core/components/auth/oauth-storage';

const isImpersonation =
  new URLSearchParams(window.location.search).get('assumeUser') === 'true' || oAuthStorage.isImpersonation();

export default {
  graphqlEndpoint: import.meta.env.VITE_STAFF_APPSYNC_BE_GRAPHQL_ENDPOINT,
  region: import.meta.env.VITE_REGION,
  authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  userPoolId: import.meta.env.VITE_STAFF_USER_POOL_ID,
  userPoolWebClientId: isImpersonation
    ? import.meta.env.VITE_STAFF_USER_POOL_IMPERSONATION_WEB_CLIENT_ID
    : import.meta.env.VITE_STAFF_USER_POOL_WEB_CLIENT_ID,
  identityPoolId: import.meta.env.VITE_STAFF_IDENTITY_POOL_ID,
  stripeKey: import.meta.env.VITE_STRIPE_KEY,
  basisTheoryApiKey: import.meta.env.VITE_BASIS_THEORY_FRONTEND_API_KEY,
  basisTheoryElementsEnv: import.meta.env.VITE_BASIS_THEORY_ELEMENTS_ENV,
  Storage: {
    bucket: import.meta.env.VITE_POLICY_DOCS_S3_BUCKET,
    region: import.meta.env.VITE_REGION,
    identityPoolId: import.meta.env.VITE_STAFF_IDENTITY_POOL_ID
  },
  Analytics: {
    disabled: true
  },
  stackeryEnvironmentName: import.meta.env.VITE_STACKERY_ENVIRONMENT,
  brandDomain: import.meta.env.VITE_BRAND_DOMAIN,
  logRocketApiKey: import.meta.env.VITE_LOGROCKET_API_KEY,
  segmentKey: import.meta.env.VITE_SEGMENT_KEY,
  friendBuyMerchantId: import.meta.env.VITE_FRIENDBUY_MERCHANT_ID,
  trackingEnabled: import.meta.env.VITE_TRACKING_ENABLED === 'true',
  smartyStreetsKey: import.meta.env.VITE_SMARTY_STREETS_KEY,
  googleGeocoderKey: import.meta.env.VITE_GOOGLE_GEOCODER_KEY,
  coreResourcesApiKey: import.meta.env.VITE_CORE_RESOURCES_API_KEY,
  coreResourcesEndpoint: import.meta.env.VITE_CORE_RESOURCES_ENDPOINT
};
